import {loggerFactory} from '../logger'

const logger = loggerFactory("RouterLoader")
// Robust chunk loader with retry mechanism and encoding validation
export function loadChunkWithRetry(importFn, maxRetries = 3) {
  let retryCount = 0;

  const loadChunk = async () => {
    try {
      const module = await importFn();
      return module;
    } catch (error) {
      retryCount++;

      // Check if it's a syntax error related to encoding corruption
      if ((error.name === 'SyntaxError' && error.message.includes('Invalid character')) ||
          error.message.includes('\ufffd') ||
          error.name === 'ChunkLoadError') {

        logger.warn(`Chunk loading failed (attempt ${retryCount}/${maxRetries}):`, error);

        if (retryCount < maxRetries) {
          // Wait before retrying with exponential backoff
          await new Promise(resolve => setTimeout(resolve, 100 * Math.pow(2, retryCount - 1)));
          return loadChunk();
        } else {
          // After max retries, force a page reload to get fresh chunks
          logger.error('Max retries exceeded for chunk loading. Reloading page...');
          window.location.reload();
          // Return a promise that never resolves to prevent further execution
          return new Promise(() => {});
        }
      }

      // Re-throw other types of errors
      throw error;
    }
  };

  return loadChunk();
}

// Preload critical chunks to avoid runtime loading issues
export function preloadAuthChunks() {
  // Only preload in browser environment
  if (typeof window !== 'undefined') {
    // Use requestIdleCallback if available, otherwise setTimeout
    const schedulePreload = window.requestIdleCallback ||
      ((callback) => setTimeout(callback, 0));

    schedulePreload(() => {
      // Preload auth layout
      import('../layouts/AuthLayout.vue').catch(error => {
        logger.warn('Failed to preload AuthLayout:', error);
      });

      // Preload auth pages
      import('../pages/Auth/LoginPage.vue').catch(error => {
        logger.warn('Failed to preload LoginPage:', error);
      });

      import('../pages/Auth/RegisterPage.vue').catch(error => {
        logger.warn('Failed to preload RegisterPage:', error);
      });
    });
  }
}
